export default "__VITE_ASSET__DVg_O2MC__"